import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type BroadcastRecorder from "./BroadcastRecorder";
import type RadioStation from "./RadioStation";

@Model()
class RadioStationsBroadcastRecorder extends ApplicationRecord {
  static jsonapiType = "radio_stations_broadcast_recorders";

  @BelongsTo() broadcastRecorder: BroadcastRecorder;

  @Attr() primary: boolean;

  @BelongsTo() radioStation: RadioStation;
}

export default RadioStationsBroadcastRecorder;
